import React from "react";
import "../Css/ReviewWidget.css";

const ReviewWidget = () => {
  return (
    <section className="review-widget-section">
      <div className="review-widget-container">

        <div className="review-widget-heading">
          <span>GOOGLE REVIEWS</span>
          <h2>What Our Customers Say</h2>
          <p>
            Read genuine reviews from our customers about their experience
            with SVK Maid Service.
          </p>
        </div>

        <div className="review-widget-frame">
          <iframe
            src="https://widgets.sociablekit.com/google-reviews/iframe/25705109"
            title="SVK Maid Service Google Reviews"
            frameBorder="0"
            width="100%"
            height="1000"
            loading="lazy"
          ></iframe>
        </div>

      </div>
    </section>
  );
};

export default ReviewWidget;